import Component from "@glimmer/component";
import { action } from "@ember/object";

import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import { on } from "@ember/modifier";

export default class extends Component {
  get type() {
    return this.args.type || "button";
  }

  get disabled() {
    return this.args.disabled || false;
  }

  @action
  onClick() {
    this.args.onClick?.();
  }

  <template>
    <button
      class="appearance-none inline-flex items-center justify-center leading-none"
      type={{this.type}}
      disabled={{this.disabled}}
      {{on "click" this.onClick}}
      {{mergeClasses}}
      ...attributes
    >
      {{yield}}
    </button>
  </template>
}
